module.exports = __webpack_public_path__ + "img/slice.5ac55e6f.png";